(function () {
  'use strict';

  var selector = '.image-video-slider';

  function slickAvailable() {
    return window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === 'function';
  }

  function asBoolean(value) {
    return String(value).toLowerCase() === 'true';
  }

  function asNumber(value, fallback) {
    var parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function forEachSlider(root, callback) {
    if (!root) return;
    if (root.matches && root.matches(selector)) callback(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(callback);
  }

  function pauseVideos(slider) {
    slider.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
  }

  function canPlay(video, slider) {
    var rect = slider.getBoundingClientRect();
    return !document.hidden && rect.bottom > 0 && rect.top < window.innerHeight &&
      !!video.closest('.slick-active');
  }

  function retryButton(video) {
    var container = video.parentElement;
    var button = container.querySelector('[data-slider-video-play]');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.textContent = 'Play video';
      button.setAttribute('data-slider-video-play', '');
      button.hidden = true;
      container.appendChild(button);
    }
    return button;
  }

  function playVideo(video, slider) {
    if (!canPlay(video, slider)) return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    var playResult = video.play();
    if (playResult && typeof playResult.catch === 'function') {
      playResult.then(function () {
        retryButton(video).hidden = true;
        if (!canPlay(video, slider)) video.pause();
      }).catch(function (error) {
        if (error.name === 'NotAllowedError' && canPlay(video, slider)) {
          retryButton(video).hidden = false;
        }
      });
    }
  }

  function playActiveVideo(slider) {
    slider.querySelectorAll('video').forEach(function (video) {
      if (canPlay(video, slider)) playVideo(video, slider);
      else video.pause();
    });
  }

  function initializeSlider(slider) {
    if (!slickAvailable()) {
      slider.style.visibility = 'visible';
      return;
    }

    var $slider = window.jQuery(slider);
    if ($slider.hasClass('slick-initialized')) return;

    function refreshVideos() { playActiveVideo(slider); }
    function retryReady(event) {
      if (event.target.tagName === 'VIDEO') playVideo(event.target, slider);
    }
    function retryClick(event) {
      var button = event.target.closest('[data-slider-video-play]');
      if (!button || !slider.contains(button)) return;
      event.stopPropagation();
      playVideo(button.parentElement.querySelector('video'), slider);
    }
    slider.addEventListener('loadeddata', retryReady, true);
    slider.addEventListener('click', retryClick);
    document.addEventListener('visibilitychange', refreshVideos);
    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(refreshVideos) : null;
    if (observer) observer.observe(slider);
    slider.sliderVideoCleanup = function () {
      if (observer) observer.disconnect();
      slider.removeEventListener('loadeddata', retryReady, true);
      slider.removeEventListener('click', retryClick);
      document.removeEventListener('visibilitychange', refreshVideos);
      $slider.off('.sliderVideos');
    };

    $slider.on('init.sliderVideos', function () {
      slider.style.visibility = 'visible';
      playActiveVideo(slider);
    });

    $slider.on('afterChange.sliderVideos', function () {
      playActiveVideo(slider);
    });
    $slider.on('setPosition.sliderVideos', refreshVideos);

    $slider.slick({
      infinite: asBoolean(slider.dataset.infinite),
      autoplay: asBoolean(slider.dataset.autoplay),
      dots: asBoolean(slider.dataset.dots),
      arrows: asBoolean(slider.dataset.arrows),
      slidesToShow: asNumber(slider.dataset.slidesToShow, 1),
      slidesToScroll: asNumber(slider.dataset.slidesToScroll, 1),
      prevArrow: '<span class="material-symbols-outlined">chevron_left</span>',
      nextArrow: '<span class="material-symbols-outlined">chevron_right</span>',
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: asNumber(slider.dataset.slidesToShowMobile, 1)
          }
        }
      ]
    });
  }

  function destroySlider(slider) {
    if (slider.sliderVideoCleanup) slider.sliderVideoCleanup();
    pauseVideos(slider);
    if (!slickAvailable()) return;

    var $slider = window.jQuery(slider);
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }

  function initializeWithin(root) {
    forEachSlider(root, initializeSlider);
  }

  function destroyWithin(root) {
    forEachSlider(root, destroySlider);
  }

  function initializePageSliders() {
    initializeWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePageSliders, { once: true });
  } else {
    initializePageSliders();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyWithin(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initializeWithin(event.target);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    destroyWithin(event.target);
  });
})();
